import { UTM_VISIT_DAIKIN } from 'constants/location';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UtmTypes } from 'redux/reducers/general/utm';

const useQueryParamsUTM = <Params extends Record<string, any>>() => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const queryObject = Object.fromEntries(new URLSearchParams(location.search || location.hash.replace('#', '?'))) as Params;
    const utmSource = document.referrer;
    if (queryObject && (location.search || location.hash)) {
      if (queryObject['utm_campaign']
        || queryObject['utm_content']
        || queryObject['utm_id']
        || queryObject['utm_medium']
        || queryObject['utm_source']
        || queryObject['utm_term']
        || utmSource
      ) {
        const isSP = window.location.pathname.split('/').length > 1 ? window.location.pathname.split('/')[1] : undefined;
        const slug = window.location.pathname.split('/').length > 2 ? window.location.pathname.split('/')[2] : undefined;

        const dataUTM: UtmTypes = {
          utmCampaign: queryObject['utm_campaign'] ?? '',
          utmContent: queryObject['utm_content'] ?? '',
          utmId: queryObject['utm_id'] ?? '',
          utmMedium: queryObject['utm_medium'] ?? '',
          utmSource: queryObject['utm_source'] ?? utmSource,
          utmTerm: queryObject['utm_term'] ?? '',
        }
        if (isSP === 'san-pham' && slug) {
          const key = `utm_slug_${slug}`;
          localStorage.setItem(key, JSON.stringify(dataUTM));
        } else {
          localStorage.setItem(UTM_VISIT_DAIKIN, JSON.stringify(dataUTM));
        }
        // dispatch(postSaveUTM(dataUTM));
      }
    }
  }, [location.search, location.hash, dispatch]);
};

export default useQueryParamsUTM;
